import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import './Profile.css';

const Profile = () => {
  const { user } = useContext(AuthContext);

  return (
    <div className="profile-page">
      <div className="profile-header">
        <h1>User Profile</h1>
        <p>View and manage your profile information</p>
      </div>

      <div className="profile-content">
        <div className="profile-card">
          <div className="profile-avatar">
            <div className="avatar-circle">
              <span className="avatar-icon">👤</span>
            </div>
          </div>

          <div className="profile-info">
            <div className="info-row">
              <label>Name</label>
              <div className="info-value">{user?.name || 'N/A'}</div>
            </div>

            <div className="info-row">
              <label>Username</label>
              <div className="info-value">{user?.username || 'N/A'}</div>
            </div>

            <div className="info-row">
              <label>Role</label>
              <div className="info-value role-badge">{user?.role || 'N/A'}</div>
            </div>

            <div className="info-row">
              <label>User ID</label>
              <div className="info-value">{user?.id || user?.userId || 'N/A'}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
